
import Vue from 'vue';
import Component from 'vue-class-component';
import { State, Action, Mutation } from 'vuex-class';

import { User } from '@/models/user.types';

@Component
export default class ForgotPasswordVerify extends Vue {
  /* VUEX */

  // ACTIONS
  @Action('authLayout')
  private authLayout: any;
  @Action('actionForgotPasswordVerify', { namespace: 'user' })
  private actionForgotPasswordVerify: any;

  // MUTATIONS
  @Mutation('mutationUser', { namespace: 'user' }) private mutationUser: any;

  // STATE
  @State('user') private user: User;

  /* INITIALIZATION */
  private isShow: boolean = false;

  constructor() {
    super();
  }

  /* LIFECYCLE */

  private created() {
    this.authLayout();

    if (this.$route.query.token) {
      this.mutationUser({ token: this.$route.query.token });
    } else {
      this.$router.push({ name: 'forgotPassword' });
    }
  }

  /* LISTENER */

  private listener() {
    this.$router.push({ name: 'login' });
  }

  private onShow(): void {
    this.isShow = !this.isShow;
  }
}
